import { useRef, useState } from "react";
import { REPLAY_VIDEO_URL } from "../../data/content";

export const VideoPlayer = ({ onMilestone }) => {
  const hit = useRef(new Set());
  const [playing, setPlaying] = useState(false);

  const onTime = (e) => {
    const v = e.target;
    if (!v.duration) return;
    const pct = (v.currentTime / v.duration) * 100;
    [25, 50, 75, 100].forEach((m) => {
      if (pct >= m && !hit.current.has(m)) {
        hit.current.add(m);
        onMilestone(m);
      }
    });
  };

  if (!REPLAY_VIDEO_URL) {
    return (
      <div className="relative aspect-video glass-card overflow-hidden group cursor-pointer cta" data-testid="replay-video-placeholder">
        <div className="absolute inset-0 grid-bg" />
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-5">
          <div className="w-20 h-20 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
            style={{ background: "var(--accent)", boxShadow: "0 0 60px rgba(68,76,231,0.5)" }}>
            <span className="text-white text-2xl ml-1">▶</span>
          </div>
          <p className="mono text-[10px] tracking-[0.3em] text-white/40">VETERAN FAST-TRACK — FULL TRAINING REPLAY</p>
          <p className="mono text-[9px] tracking-[0.2em] text-[var(--accent)]">[REPLAY VIDEO PLACEHOLDER — SWAP IN FINAL RECORDING]</p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/10">
          <div className="h-full w-0" style={{ background: "var(--accent)" }} />
        </div>
      </div>
    );
  }

  return (
    <div className="relative aspect-video glass-card overflow-hidden" data-testid="replay-video-player">
      <video
        className="w-full h-full object-cover"
        src={REPLAY_VIDEO_URL}
        controls
        playsInline
        onPlay={() => setPlaying(true)}
        onTimeUpdate={onTime}
        style={{ accentColor: "var(--accent)" }}
      />
      {!playing && <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: "inset 0 0 120px rgba(68,76,231,0.15)" }} />}
    </div>
  );
};
